import { saveLocalToCookie } from 'lib/sessions-manager';

saveLocalToCookie('most_recent_resource_id');
